import {get, isNil, isEmpty} from 'lodash'
import {getContactLabel} from 'helpers/contacts'
import {sortByLabel} from "helpers/sorting"

export const getCompanyOption = (entity) => {
  if (isNil(entity))
    return null

  const company = get(entity, 'company', null)
  if (isNil(company))
    return null

  const value = get(company, 'id', null)
  const label = get(company, 'name', null)
  return {
    ...company,
    value,
    label,
  }
}

export const getContactOption = (entity) => {
  if (isNil(entity))
    return null

  const contact = get(entity, 'contact', null)
  if (isNil(contact))
    return null

  const value = get(contact, 'id', null)
  const label = getContactLabel(contact)
  return {
    ...contact,
    value,
    label,
  }
}

export const getFieldOptionValues = (key, fieldOptions) => {
  if (isEmpty(fieldOptions))
    return []

  const options = fieldOptions.find(fieldOption => fieldOption.key === key)
  return get(options, 'values', []).map(option => {
    return {
      id: option.value,
      value: option.value,
      key: option.value,
      label: option.label,
      name: option.label,
      fieldOption: option,
    }
  })
}


export const deleteTeam = (id, teams) => {
  const deletedTeamArray = teams.filter(team => team.id === id)
  let finalTeamArray = teams.filter(team => team.id !== id)

  const filterItems = (deletedTeamObject) => {
    const deletedParentIdsArray = teams.filter(team => team.parentId === deletedTeamObject.id)
    finalTeamArray = finalTeamArray.filter(team => team.parentId !== deletedTeamObject.id)
    for (let i = 0; i < deletedParentIdsArray.length; i++) {
      filterItems(deletedParentIdsArray[i])
    }
  }

  for (let i = 0; i < deletedTeamArray.length; i++) {
    filterItems(deletedTeamArray[i])
  }
  return finalTeamArray
}

export const getAccountingDepartmentOptions = (accountingDepartments, currentValue) => {
  const isInList = accountingDepartments.some(department => department.name === currentValue)

  if (!isInList && !isNil(currentValue)) {
    accountingDepartments.push({name: currentValue})
  }

  return accountingDepartments
      .map(department => ({
        key: department.name,
        label: department.name,
        value: department.name,
      })).sort((a, b) => sortByLabel(a, b))
}
